<template>
    <Layout>
      <PageHeader :title="title" :items="items" />
  
      <div class="row" v-if="userData.permissions['patient_visits']==1">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
                <div class="row">
                  <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center">
                        Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                      </label>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                      <label class="d-inline-flex align-items-center">
                        Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="table-responsive">
                  <b-table
                    :items="Items"
                    :fields="Fields"
                    responsive="sm"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    @filtered="Filtered"
                    :busy="IsBusy"
                  >
                  <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(telephone)="data">
                    0{{ data.item.patient.telephone }}
                  </template>
                  <template #cell(patient_id)="data">
                    {{ data.item.patient.patient_id }}
                  </template>
                  <template #cell(name)="data">
                    {{ data.item.patient.name }}
                  </template>
                  <template #cell(prescription)="data">
                    <b-button @click="view(data.item.patient.patient_id,data.item.visit_id,data.item.patient.name,data.item.patient.gender,data.item.patient.telephone)" type="button" class="btn-sm btn" variant="info" v-b-modal.view> <i class="mdi mdi-eye"></i> view</b-button>                 
                  </template>
                  <template #cell(status)="data">
                    <span v-if="((data.item.status) == 1)">
                      <b-button @click="pay(data.item.id,data.item.patient.name,data.item.patient.gender,data.item.patient.telephone,data.item.patient.patient_id,data.item.visit_id)" type="button" class="btn-sm btn" variant="primary" v-b-modal.edit><i class="mdi mdi-pill"></i> dispense</b-button>
                    </span>
                    <span v-else class="text-primary">
                        <i class="fas fa-check"></i> Taken
                    </span>
                  </template>
                  </b-table>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="dataTables_paginate paging_simple_numbers float-end">
                      <ul class="pagination pagination-rounded mb-0">
                        <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="row justify-content-center">
          <div class="col-md-8 col-xl-6">
            <div>
              <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
              <center><span class="text-primary h6">You have no permission to View Patients Visits</span></center>
            </div>
          </div>
        </div>
      </div>
      
      <b-modal id="view-medicine" centered title="View Patient Prescriptions" title-class="font-14" hide-footer>
        <h6 class="text-dark"> Name : <span class="text-primary">{{ name }}</span>
        Gender : <span class="text-primary">{{ gender }}</span>
        Telephone : <span class="text-primary">0{{ telephone }}</span></h6>
        <table class="table table-sm mt-2" style="color: black;" density="compact">
        <thead><tr><th>Medicine</th><th>Unit</th><th>Price</th></tr></thead>
          <tbody>
          <tr v-for="item in prescriptions" :key="item.id">
              <td>{{ item.medicine.name }}</td>
              <td>{{ item.quantity }} {{ item.unit.unit_name }}</td>
              <td>{{ item.totalprice }}</td>
              </tr>
          </tbody>
        </table>

        <div class="form-group d-flex justify-content-end">
            <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('view-medicine')" >Close</b-button>
        </div>
      </b-modal>
  
      <b-modal id="view-pay" centered title="Dispense Medicine " title-class="font-14" hide-footer>
        <h6 class="text-dark"> Name : <span class="text-primary">{{ name }}</span>
         Gender : <span class="text-primary">{{ gender }}</span>
         Telephone : <span class="text-primary">0{{ telephone }}</span></h6>
         <table class="table table-sm mt-2" style="color: black;" density="compact">
        <thead><tr><th>Medicine</th><th>Unit</th><th>Price</th></tr></thead>
          <tbody>
          <tr v-for="item in prescriptions" :key="item.id">
              <td>{{ item.medicine.name }}</td>
              <td>{{ item.quantity }} {{ item.unit.unit_name }}</td>
              <td>{{ item.totalprice }}</td>
              </tr>
          </tbody>
        </table>
         <form @submit.prevent="addDispense">
              <input v-model="patient_id" type="hidden"/>
              <input v-model="visit_id" type="hidden"/>
              <div class="form-group mb-2">
              <label>Dispense Note</label>
              <textarea model="dispensenote" class="form-control"></textarea>
              </div>
              <div class="form-group mb-2">
              <label>Dispense Date</label>
              <input v-model="dispensedate" type="date" class="form-control"/>
              </div>
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('view-pay')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
          </form>
      </b-modal>
    </Layout>
  </template>
  
  <script>
  import axios from "axios";
  import Layout from "../../layouts/main";
  import PageHeader from "@/components/page-header";
  import appConfig from "@/app.config";
  import { dispensemedicineMethods, dispensemedicineComputed } from "@/state/helpers";
  
  export default {
    page: {
      title: "Dispense Medicine",
      meta: [{ name: "description", content: appConfig.description,},],
    },
    components: {
      Layout,PageHeader
    },
    data() {
      return {
        userData: JSON.parse(localStorage.getItem("user")),
        title: "Dispense Medicine",
        items: [ {text: "Dashboard",to: "/",}, {text: "Dispense Medicine",active: true, }, ],
        TotalRows: 1,
        currentPage: 1,
        perPage: 10,
        Options: [10, 50, 100, 150, 200],
        filter: null,
        filterOn: [],
        sortDesc: true,
        isBusy: true,
        fields: [
            { key: 'index', label: '#', visible: true },
            { key: 'id', label: 'ID', visible: false },
            { key: 'patient_id', label: 'Patient ID', visible: true },
            { key: 'name', label: 'Name', visible: true },
            { key: 'telephone', label: 'Telephone', visible: true },
            { key: 'status', label: 'Status', visible: true },
            { key: 'prescription', label: 'prescription', visible: true },
          ],
        prescriptions:[],
        id:'',
        telephone:'',
        name:'',
        gender:'',
        patient_id:'',
        visit_id:'',
        dispensenote:'',
        dispensedate:new Date().toLocaleDateString('fr-CA'),
      };
    },
    computed: {
      ...dispensemedicineComputed,
      List() { return this.dispensemedicines.length; },
      Fields() { return this.fields.filter(field => field.visible) },
      Items() { return this.dispensemedicines.map((d) => ({...d }))},
      IsBusy() { let a=false; if (this.dispensemedicines.length>0) { a=false;} else { a=true;} return a },
      Medicines() { return this.prescriptions.map((d) => ({id:d.medicine.id,name:d.medicine.name,unit:d.unit.id,quantity:d.quantity }))},
    },
    mounted() {
      this.fetchDispenseMedicine();
      this.TotalRows = this.dispensemedicines.length;
      this.isBusy=false;
    },
    methods: {
      ...dispensemedicineMethods,
      Filtered(filteredItems) {
        this.TotalRows = filteredItems.length;
        this.currentPage = 1;
      },
      async view(id,visit_id,name,gender,telephone){
      this.id=id;
      this.visit_id=visit_id;
      this.name=name;
      this.gender=gender;
      this.telephone=telephone;
      let formData = new FormData();
      formData.append("patient_id", this.id);
      formData.append("visit_id", this.visit_id);
      let url = "/patientprescription";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.prescriptions=response.data.prescriptions;
        this.$bvModal.show('view-medicine')
      }
    })
    },
      async pay(id,name,gender,telephone,patient_id,visit_id){
      this.id=id;
      this.name=name;
      this.gender=gender;
      this.telephone=telephone;
      this.patient_id=patient_id;
      this.visit_id=visit_id;
      let formData = new FormData();
      formData.append("patient_id", this.patient_id);
      formData.append("visit_id", this.visit_id);
      let url = "/patientprescription";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.prescriptions=response.data.prescriptions;
      } })
      this.$bvModal.show('view-pay')
      },
      async addDispense() { 
        let obj = {prescriptions:this.Medicines, patient:this.patient_id, visit_id:this.visit_id, dispense_note:this.dispensenote, dispense_date:this.dispensedate }
        let url = "/adddispenseprescription";
        await axios.post(url, obj).then((response) => {
        if (response.status == 200) {
            this.fetchDispenseMedicine();
            this.$bvModal.hide('view-pay');
            this.patient="";
            this.visit_id="";
            this.dispense_note="";
            this.dispense_date="";
            this.prescriptions="";
            this.$toast.success("Patient Description Added");
        }
        });
      },
    },
  };
  </script>